// @flow
import React, { Component } from "react";
import CodePush from "react-native-code-push";
import { View, StyleSheet, Text } from "react-native";
import { Loading } from "./components/common";
import i18n from "@microdoing/shared/i18n";
import theme from "./Theme/Theme";

const fixDecimal = (number, numberOfDecimal) =>
  parseInt(number?.toFixed(numberOfDecimal) || 0, 10);

const styles = StyleSheet.create({
  wrapperStyle: {
    backgroundColor: "#0395FF",
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    zIndex: 1000,
  },
  codePushStatus: {
    marginTop: 20,
    color: theme.colors["neutral.white"],
    fontSize: 18,
  },
  loaderWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
});

class CodepushLoading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      codePushStatus: 0,
      codePushProgress: 0,
      url: "",
    };
  }

  getCodePushStatus() {
    switch (this.props.codePushStatus) {
      case CodePush.SyncStatus.UPDATE_INSTALLED:
        return i18n.t("codepush-installed");
      case CodePush.SyncStatus.INSTALLING_UPDATE:
        return i18n.t("codepush-installing");
      case CodePush.SyncStatus.DOWNLOADING_PACKAGE:
        return i18n.t("codepush-downloading");
      default:
        return i18n.t("codepush-update");
    }
  }

  render() {
    if (!this.props.isLoading) return null;

    return (
      <View style={styles.wrapperStyle}>
        {this.props.isLoading && <Loading size={45} />}
        <Text style={styles.codePushStatus}>
          {this.getCodePushStatus(this.props.codePushStatus)}
        </Text>
        <Text style={styles.codePushStatus}>{`${fixDecimal(
          this.props.codePushProgress,
          2,
        )}%`}</Text>
      </View>
    );
  }
}

export default CodepushLoading;
